<template>
  <div v-if="! profile && loginUrl">
    <div class="gmf-context gmf-profile-dropdown-btn" @click.stop.prevent="login">
      <Icon class="gmf-profile-dropdown-btn-icon" icon="notification-bell" />
    </div>
    <LoginCTA v-if="loginCTAEnabled" :overrideOpen="overrideLoginPopup" @close="overrideLoginPopup = false" />
  </div>
  <div v-else-if="profile">
    <div class="gmf-context gmf-profile-dropdown-btn" @click="open">
      <Avatar v-if="shouldShowAvatar" animated :customer="profile" :disablePopup="true" :disableOnlineIndicator="true" />
      <Icon v-else class="gmf-profile-dropdown-btn-icon" icon="notification-bell" />
      <div class="gmf-notif-dropdown-btn-count" v-text="combinedNotificationCount" ref="count" v-if="combinedNotificationCount > 0"></div>
    </div>
  </div>
</template>

<style>
.gmf-profile-dropdown-btn {
  height: 50px;
  width: 50px;
  position: relative;
  background-color: #ffffff00;

  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.gmf-profile-dropdown-btn .gmf-avatar {
  width: 100%;
  height: 100%;
}
.gmf-profile-dropdown-btn object {
  pointer-events: none;
}

.gmf-profile-dropdown-btn-icon {
  width: 50%;
  height: 50%;
}

.gmf-dropdown-profile-header {
  flex-shrink: 0;
}


.gmf-profile-dropdown {
  transition: opacity 0.1s linear;
  background: var(--gmf-col-white);
  width: 420px;
  max-width: 100%;
  border-radius: var(--gmf-rounding);
  display: flex;
  flex-direction: column;
  box-shadow: 0px 1px 6px rgba(0,0,0,.2);
  max-height: min(75vh, 650px);
  overflow-x: hidden;
  overflow-y: auto;

  cursor: default;
}

.gmf-profile-dropdown .gmf-compact-profile-card-wrap {
  margin: var(--gmf-p-4);
}
</style>

<script>
import state from '@/state';
import callApi from '@/utils/callApi';
import requestLogin from '@/utils/requestLogin';
import LoginCTA from '@/widgets/LoginCTA';
import openPopupProfile from '@/components/PopupProfileCard/openPopupProfileCard';
import notificationFetcher from '@/widgets/Notifications/notificationFetcher';

import Icon from '@/components/Icon';
import Avatar from '@/components/Avatar';
import openTutorialModal from '../Tutorial/openTutorialModal';
import { getLocalizedString } from '@/utils/getLocalizedString';

const t = state.t.prefix('profile_tabs');

export default {
  name: 'ProfileDropdown',
  components: {
    Icon,
    Avatar,
    LoginCTA,
  },
  async created () {
    notificationFetcher.addEventListener('newNotificationCount', this.onNewNotificationCount);
  },
  async mounted () {
    if (this.showDMs) {
      setTimeout(this.getNewDMCount, 500);

      this.dmInterval = setInterval(this.getNewDMCount, 6000);
    }
  },
  async unmounted () {
    if (this.dmInterval) {
      clearInterval(this.dmInterval);
    }
    notificationFetcher.removeEventListener('newNotificationCount', this.onNewNotificationCount);
  },
  data () {
    return {
      state,
      newNotificationCount: notificationFetcher.getNewNotificationCount(),
      unseenMessageCount: 0,

      dmInterval: null,
      overrideLoginPopup: false,
    };
  },
  methods: {
    t,
    login () {
      setTimeout(() => {
        if (this.loginCTAEnabled) {
          this.overrideLoginPopup = ! this.overrideLoginPopup;
          return;
        }
        requestLogin();
      });
    },
    onNewNotificationCount (count) {
      if (this.newNotificationCount !== count) {
        this.newNotificationCount = count;
      }
    },
    consumeClick (ev) {
      if (ev && ev.target != this.$refs.myPagesBtn) {
        ev.preventDefault();
        ev.stopPropagation();
      }
    },
    open (ev) {
      if (ev) {
        ev.preventDefault();
        ev.stopPropagation();
      }

      this.unseenMessageCount = 0;
      openPopupProfile(this.profile.id, this.defaultPopupTab);

      if (this.tutorialEnabled && this.tutorialAutoOpenEnabled && ! this.hasCompletedTutorial) {
        openTutorialModal();
      }
    },
    async getNewDMCount () {
      if (document.visibilityState === 'hidden') {
        return;
      }
      if (! this.$el.offsetParent) { // element is invisible
        return;
      }
      if (! this.profile) {
        return;
      }
      const res = await callApi('GET', '/v1/client/dm/new');
      const { unseenMessageCount } = await res.json();
      this.unseenMessageCount = unseenMessageCount;
    },
  },
  computed: {
    combinedNotificationCount () {
      return this.newNotificationCount + this.unseenMessageCount;
    },
    loginUrlParam() {
      return state.merchantConfig?.loginUrl || '';
    },
    loginUrl () {
      return getLocalizedString(this.loginUrlParam);
    },
    shouldShowAvatar () {
      if (! state.merchantConfig.widgets?.dropdownProfilePage?.useAvatarAsIcon) {
        return false;
      }
      return !! this.profile;
    },
    customizable () {
      return state.merchantConfig?.avatars?.enabled === 'enabled' || state.merchantConfig?.avatars?.enabled === '3D';
    },
    showDMs () {
      return state.merchantConfig.directMessages.enabled;
    },
    profile() {
      return this.state.profile;
    },
    loginCTAEnabled () {
      return state.merchantConfig?.widgets?.loginCTA?.enabled;
    },
    hasCompletedTutorial() {
      return (this.profile.flags || []).includes('completed_tutorial');
    },
    tutorialEnabled() {
      return state.merchantConfig?.widgets?.tutorial?.enabled;
    },
    tutorialAutoOpenEnabled() {
      return state.merchantConfig?.widgets?.tutorial?.autoOpen;
    }
  },
};
</script>
